import { DeviceGroups, DeviceIds, type DeviceId } from '@libs/define/device_registry'
import { MagnetSeniorType } from '@libs/types/enum'

export const DPI_LEVEL_MAX = 5

export type KK = number & { __brand: 'KK' }
export type VK = number & { __brand: 'VK' }
export type LK = number & { __brand: 'LK' }
export type DVK = number & { __brand: 'VK' }
export type DefineDevice = DeviceId

export type KeyMap = [number, number, number, number]

export const ToReset: VK = 0 as VK

export const VirtualHE3SEWireless_24g: DefineDevice = DeviceIds.IROKHe3SE_Wireless_24g
export const VirtualHE3SEWireless: DefineDevice = DeviceIds.IROKHe3SE_Wireless
export const VirtualNa87ProWired: DefineDevice = DeviceIds.IROKNa87Pro
export const VirtualNd63: DefineDevice = DeviceIds.IROKNd63
export const VirtualMu68Pro: DefineDevice = DeviceIds.IYXMu68Pro
export const VirtualMu68Pro_Cyan: DefineDevice = DeviceIds.IYXMu68Pro_cyan
export const VirtualMu68_ULTRA: DefineDevice = DeviceIds.IYXMu68_ULTRA
export const VirtualNd63_Cyan: DefineDevice = DeviceIds.IROKNd63_cyan
export const VirtualPolar75: DefineDevice = DeviceIds.IYXPolar75

export const VirtualMars68ProWireless: DefineDevice = DeviceIds.CarotmasMars68Pro_Wireless
export const VirtualMars68ProWireless_24g: DefineDevice = DeviceIds.CarotmasMars68Pro_Wireless_24g
export const VirtualMars68Pro: DefineDevice = DeviceIds.CarotmasMars68Pro
export const VirtualMars68SE: DefineDevice = DeviceIds.CarotmasMars68SE
export const VirtualMars68: DefineDevice = DeviceIds.CarotmasMars68
export const VirtualMars68Wireless: DefineDevice = DeviceIds.CarotmasMars68_Wireless
export const VirtualMars68Wireless_24g: DefineDevice = DeviceIds.CarotmasMars68_Wireless_24g

export const VirtualMonsGeek: DefineDevice = DeviceIds.MonsGeek
export const VirtualMonsGeek_NoLight: DefineDevice = DeviceIds.MonsGeek_NoLight
export const VirtualMonsGeek_NoLight_24g: DefineDevice = DeviceIds.MonsGeek_NoLight_24g

export const VirtualMg68: DefineDevice = DeviceIds.IROKMg68
export const VirtualMg68SE: DefineDevice = DeviceIds.IROKMg68SE
export const VirtualMg68Pro: DefineDevice = DeviceIds.IROKMg68Pro
export const VirtualMg68Lite: DefineDevice = DeviceIds.IROKMg68LITE
export const VirtualMG68ACE: DefineDevice = DeviceIds.IROKMG68ACE
export const VirtualMG68ACE_UpPlus: DefineDevice = DeviceIds.IROKMG68ACE_UpPlus
export const VirtualMG68ACE_W: DefineDevice = DeviceIds.IROKMG68ACE_W
export const VirtualMG68ACE_W_24g: DefineDevice = DeviceIds.IROKMG68ACE_W_24g
export const VirtualMg68Max: DefineDevice = DeviceIds.IROKMg68Max
export const VirtualMg68Max_24g: DefineDevice = DeviceIds.IROKMg68Max_24g

export const VirtualMg75: DefineDevice = DeviceIds.IROKMg75
export const VirtualMg75Pro: DefineDevice = DeviceIds.IROKMg75PRO

export const VirtualMer68: DefineDevice = DeviceIds.CarotmasMer68
export const VirtualMer68Pro: DefineDevice = DeviceIds.CarotmasMer68Pro
export const VirtualMer68SE: DefineDevice = DeviceIds.CarotmasMer68SE
export const VirtualMer68Lite: DefineDevice = DeviceIds.CarotmasMer68Lite
export const VirtualMer68Max: DefineDevice = DeviceIds.CarotmasMer68Max
export const VirtualMer68SE_JT: DefineDevice = DeviceIds.CarotmasMer68SE_JT

export const VirtualHe6Ultra: DefineDevice = DeviceIds.He6Ultra
export const VirtualHe6Ultra_24g: DefineDevice = DeviceIds.He6Ultra_24g

export const VirtualMg75Max: DefineDevice = DeviceIds.IROKMg75Max
export const VirtualMg68Plus: DefineDevice = DeviceIds.IROKMg68Plus
export const VirtualMars75: DefineDevice = DeviceIds.CarotmasMars75
export const VirtualMars75Pro: DefineDevice = DeviceIds.CarotmasMars75Pro

export const VirtualND68: DefineDevice = DeviceIds.IROKND68
export const VirtualND63Max: DefineDevice = DeviceIds.IROKND63Max
export const VirtualND68Pro: DefineDevice = DeviceIds.IROKND68Pro
export const VirtualND63Ultra: DefineDevice = DeviceIds.IROKND63Ultra
export const VirtualRA68: DefineDevice = DeviceIds.IROKRA68

export const VirtualIrokFe87V2: DefineDevice = DeviceIds.IrokFe87V2
export const VirtualIrokFe87V2_24g: DefineDevice = DeviceIds.IrokFe87V2_24g
export const VirtualIrokFe87V2IMC: DefineDevice = DeviceIds.IrokFe87V2IMC
export const VirtualIrokFe87V2IMC_24g: DefineDevice = DeviceIds.IrokFe87V2IMC_24g
export const VirtualIrokFe87V2C18: DefineDevice = DeviceIds.IrokFe87V2C18
export const Fe87v2Devices: DefineDevice[] = [...DeviceGroups.Fe87v2]
export const VirtualMer68SESelfDev: DefineDevice = DeviceIds.CarotmasMer68SESelfDev

export const VirtualMG63: DefineDevice = DeviceIds.IROKMG63
export const VirtualRA68_1: DefineDevice = DeviceIds.IROKRA68_1
export const VirtualMG75V2C12: DefineDevice = DeviceIds.IROKMG75V2C12
export const VirtualMG63V2: DefineDevice = DeviceIds.IROKMG63V2
export const HuoChaiRenDevices: DefineDevice[] = [...DeviceGroups.HuoChaiRen]

export const VirtualFE87V2_MuYan: DefineDevice = DeviceIds.IROKFE87V2_MuYan
export const ZhiHuiWuXian_Device: DefineDevice[] = [...DeviceGroups.ZhiHuiWuXian]

export const JingTaiMg75Devices: DefineDevice[] = [...DeviceGroups.JingTaiMg75]
export const JingTaiMer68Devices: DefineDevice[] = [...DeviceGroups.JingTaiMer68]
export const RoYuanDevice: DefineDevice[] = [...DeviceGroups.RoYuanMars68, ...DeviceGroups.RoYuanMonsGeek, ...DeviceGroups.RoYuanMg68, ...DeviceGroups.RoYuanMer68, ...DeviceGroups.RoYuanND68, ...DeviceGroups.RoYuanND63]
export const JingTaiV2Devices: DefineDevice[] = [...DeviceGroups.JingTaiV2]

export type KeyCode = [number, number, number?]
export type KeyFunction = [number, number, number, number]

interface SetMagnetKey {
  KeyCode: KeyCode
  KeyFunction: KeyFunction
  Travel: number
}

export interface SetMagnetSenior {
  KeyType: MagnetSeniorType
  Keys: [SetMagnetKey, SetMagnetKey, SetMagnetKey, SetMagnetKey]
  MTDuration: number
  TGLEnable: number
  TGLMode: number
  KMEMode: [number, number]
  DelayTime: 0
}

export interface DataTravel {
  PressNum: number
  ReleaseNum: number
  QuickTriggerPressNum: number
  QuickTriggerReleaseNum: number
}

export interface Record {
  Key: VK
  Press: boolean
  Delay: number
}

export interface Layout {
  KeyMap: Map<KK, number>
  KeyMapModifier: Map<KK, number[]>
  Magenet: Map<KK, SetMagnetSenior>
  KeyMapFire: Map<KK, number[]>
  Macros: Map<KK, Record[]>
  MacroType: Map<KK, MacroType>
}

export interface MacroType {
  LoopType: number
  LoopTimes: number
}

export interface KIO {
  Input: Input
  Output: Output
}

export interface Input {
  KK: KK
  WithFN: boolean
  WithModifier: VK[]
}

export interface Output {
  Mode: OutputMode
  VK: VK
  DataIndex: number
  Extension: number[]
}

export enum OutputMode {
  Key = 0,
  Macro = 1,
  Magnet = 2,
  Fire = 3,
}
